import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { StartHere } from './pages/StartHere';
import { PersonalProtocol } from './pages/PersonalProtocol';
import { ToolsLibrary } from './pages/ToolsLibrary';
import { Compliance } from './pages/Compliance';
import { RiskAssessment } from './pages/RiskAssessment';
import { About } from './pages/About';
// Organization Protocol
import { Organization } from './pages/Organization';
import { Govern } from './pages/organization/Govern';
import { Identify } from './pages/organization/Identify';
import { Protect } from './pages/organization/Protect';
import { Detect } from './pages/organization/Detect';
import { Respond } from './pages/organization/Respond';
import { Recover } from './pages/organization/Recover';
// Personal Protocol Details
import { Identity } from './pages/personal/Identity';
import { Communication } from './pages/personal/Communication';
import { DataBackup } from './pages/personal/DataBackup';
import { Internet } from './pages/personal/Internet';
import { IncidentResponse } from './pages/personal/IncidentResponse';
// Device Library
import { IOS } from './pages/devices/iOS';
import { Android } from './pages/devices/Android';
import { Windows } from './pages/devices/Windows';
import { MacOS } from './pages/devices/macOS';
import { Linux } from './pages/devices/Linux';
// Incident Response
import { AccountTakeover } from './pages/ir/AccountTakeover';
import { LostDevice } from './pages/ir/LostDevice';
// Tools Details
import { BreachCheck } from './pages/tools/BreachCheck';
import { PasswordSafety } from './pages/tools/PasswordSafety';
import { MFAPasskeys } from './pages/tools/MFAPasskeys';
import { Privacy } from './pages/tools/Privacy';
import { Backup } from './pages/tools/Backup';
import { BusinessSecurity } from './pages/tools/BusinessSecurity';
// Compliance Details - ONLY Global and Indonesia
import { Global } from './pages/compliance/Global';
import { Indonesia } from './pages/compliance/Indonesia';
// About Subpages
import { Mission } from './pages/about/Mission';
import { Scope } from './pages/about/Scope';
import { StandardsMapping } from './pages/about/StandardsMapping';
import { Changelog } from './pages/about/Changelog';
import { Governance } from './pages/about/Governance';
import { Disclaimer } from './pages/about/Disclaimer';
import { Contact } from './pages/about/Contact';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        {/* Core Pages */}
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/start" element={<StartHere data-id="element-6" />} data-id="element-5" />
        <Route path="/personal" element={<PersonalProtocol data-id="element-8" />} data-id="element-7" />
        <Route path="/tools" element={<ToolsLibrary data-id="element-10" />} data-id="element-9" />
        <Route path="/compliance" element={<Compliance data-id="element-12" />} data-id="element-11" />
        <Route path="/risk-assessment" element={<RiskAssessment data-id="element-14" />} data-id="element-13" />
        <Route path="/about" element={<About data-id="element-16" />} data-id="element-15" />

        {/* Organization Protocol */}
        <Route path="/organization" element={<Organization data-id="element-18" />} data-id="element-17" />
        <Route path="/organization/govern" element={<Govern data-id="element-20" />} data-id="element-19" />
        <Route path="/organization/governance" element={<Govern data-id="element-22" />} data-id="element-21" />
        <Route path="/organization/identify" element={<Identify data-id="element-24" />} data-id="element-23" />
        <Route path="/organization/protect" element={<Protect data-id="element-26" />} data-id="element-25" />
        <Route path="/organization/detect" element={<Detect data-id="element-28" />} data-id="element-27" />
        <Route path="/organization/respond" element={<Respond data-id="element-30" />} data-id="element-29" />
        <Route path="/organization/recover" element={<Recover data-id="element-32" />} data-id="element-31" />

        {/* Personal Protocol Details */}
        <Route path="/personal/identity" element={<Identity data-id="element-34" />} data-id="element-33" />
        <Route path="/personal/communication" element={<Communication data-id="element-36" />} data-id="element-35" />
        <Route path="/personal/data-backup" element={<DataBackup data-id="element-38" />} data-id="element-37" />
        <Route path="/personal/internet" element={<Internet data-id="element-40" />} data-id="element-39" />
        <Route path="/personal/incident-response" element={<IncidentResponse data-id="element-42" />} data-id="element-41" />

        {/* Device Library */}
        <Route path="/devices/ios" element={<IOS data-id="element-44" />} data-id="element-43" />
        <Route path="/devices/android" element={<Android data-id="element-46" />} data-id="element-45" />
        <Route path="/devices/windows" element={<Windows data-id="element-48" />} data-id="element-47" />
        <Route path="/devices/macos" element={<MacOS data-id="element-50" />} data-id="element-49" />
        <Route path="/devices/linux" element={<Linux data-id="element-52" />} data-id="element-51" />

        {/* Incident Response */}
        <Route path="/ir/account-takeover" element={<AccountTakeover data-id="element-54" />} data-id="element-53" />
        <Route path="/ir/lost-device" element={<LostDevice data-id="element-56" />} data-id="element-55" />

        {/* Tools Details */}
        <Route path="/tools/breach-check" element={<BreachCheck data-id="element-58" />} data-id="element-57" />
        <Route path="/tools/password-safety" element={<PasswordSafety data-id="element-60" />} data-id="element-59" />
        <Route path="/tools/mfa-passkeys" element={<MFAPasskeys data-id="element-62" />} data-id="element-61" />
        <Route path="/tools/privacy" element={<Privacy data-id="element-64" />} data-id="element-63" />
        <Route path="/tools/backup" element={<Backup data-id="element-66" />} data-id="element-65" />
        <Route path="/tools/business-security" element={<BusinessSecurity data-id="element-68" />} data-id="element-67" />

        {/* Compliance Details - ONLY Global and Indonesia */}
        <Route path="/compliance/global" element={<Global data-id="element-70" />} data-id="element-69" />
        <Route path="/compliance/indonesia" element={<Indonesia data-id="element-72" />} data-id="element-71" />

        {/* About Subpages */}
        <Route path="/about/mission" element={<Mission data-id="element-74" />} data-id="element-73" />
        <Route path="/about/scope" element={<Scope data-id="element-76" />} data-id="element-75" />
        <Route path="/about/standards" element={<StandardsMapping data-id="element-78" />} data-id="element-77" />
        <Route path="/about/changelog" element={<Changelog data-id="element-80" />} data-id="element-79" />
        <Route path="/about/governance" element={<Governance data-id="element-82" />} data-id="element-81" />
        <Route path="/about/disclaimer" element={<Disclaimer data-id="element-84" />} data-id="element-83" />
        <Route path="/about/contact" element={<Contact data-id="element-86" />} data-id="element-85" />
      </Routes>
    </Router>;
}